var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-filter-advanced-section',{staticClass:"section",class:{'is-locked': _vm.locked}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }